'use strict';

//Fetch module (defined in app.js)
angular.module('App.v1.Services')

	//******************** SERVICES *****************************************************************
	.factory('App.v1.Services.Response', ['$resource', '$filter',
		function ($resource, $filter) {
			return $resource(
				'/api/response/:id',
				{},
				{
					'create': { method: 'POST', isArray: false },
					'list': { method: 'GET', isArray: false },
					'get': { method: 'GET', isArray: false },
					'update': { method: 'PATCH' },
					'delete': { method: 'DELETE' },
					'reply': { method: 'POST', url: '/api/response/:id/conversations', isArray: false },
					'counts': { method: 'GET', url: '/api/response/counts', isArray: true }
				}
			);
		}]);